function addToNavigationHistory(url) {
  window.Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier(
    url,
    window.Turbolinks.uuid()
  );
}

export default addToNavigationHistory;
